import { COUNTRY_CODES } from "../constants/countries";
import { anotarAvisoDeProceso } from "../services/syncLog";

/**
 * La configuración de un país, y un aviso cuando no la hay.
 *
 * Once registros del terminal se resuelven como `CONFIG[pais] || CONFIG[EC]`:
 * el formulario de cliente y sus permisos, las denominaciones, el panel de
 * inicio, el formulario de factura, sus líneas y su listado, el menú, los tipos
 * de documento, los documentos de identidad y los modelos de la base local.
 *
 * El respaldo a Ecuador es correcto —hay que dibujar algo— pero **incorporar un
 * país nunca falla: se convierte en Ecuador**. Guatemala tiene configuración de
 * líneas y de listado pero no de formulario, así que su pantalla de venta sale
 * con la cabecera de Ecuador; Bolivia no está en ninguno de los once. Nada lo
 * dice: la pantalla se dibuja y parece que el país está soportado.
 *
 * Esto no inventa configuraciones que no existen. Lo que hace es que el hueco se
 * vea: la primera vez que un país cae al respaldo, en cada registro, queda una
 * línea en la consola con el nombre del registro y el país. Así, incorporar un
 * país es leer esa lista en vez de descubrir los huecos de pantalla en pantalla.
 */

// Un aviso por registro y país, no uno por cada dibujo del componente.
const yaAvisados = new Set();

/**
 * @param {Object} registro   El mapa de configuraciones, por código de país.
 * @param {string} pais       Código del país activo.
 * @param {string} nombre     Cómo se llama el registro, para el aviso.
 * @returns {*} La configuración del país, o la de Ecuador si no la tiene.
 */
export const configuracionDePais = (registro, pais, nombre) => {
  const propia = registro?.[pais];
  if (propia) return propia;

  const clave = `${nombre}·${pais}`;
  if (!yaAvisados.has(clave)) {
    yaAvisados.add(clave);
    anotarAvisoDeProceso(
      `${nombre}: no hay configuración para «${pais || "(sin país)"}», se usa la de Ecuador`
    );
  }

  return registro?.[COUNTRY_CODES.ECUADOR];
};

/** Sólo para las pruebas: vuelve a avisar de lo ya avisado. */
export const olvidarAvisosDeConfiguracion = () => yaAvisados.clear();
